import { httpsCallable, getFunctions } from 'firebase/functions';
import app from '../config/firebase';

const functions = getFunctions(app!);

export type PaymentRecord = {
  id: string;
  pfPaymentId: string;
  paymentStatus: string;
  productId: string;
  planId: string;
  amountGross: string;
  amountFee: string;
  amountNet: string;
  itemName: string;
  billingDate: string | null;
  createdAt: any;
  adminGenerated: boolean;
};

export type SubscriptionInfo = {
  plan: string;
  status: string;
  origin: string;
  payfast: {
    subscriptionId: string | null;
    token: string | null;
    lastTxnAt: string;
    amount: string | null;
    subscriptionStatus: string | null;
    nextBillingDate: string | null;
  } | null;
  payfastLive: {
    status_text: string;
    run_date: string;
    amount: number;
    cycles_complete: number;
    frequency: number;
  } | null;
};

export const callGetPaymentHistory = async (payload?: { limit?: number }) => {
  const fn = httpsCallable(functions, 'getPaymentHistory');
  const res = await fn(payload || {});
  return res.data as { payments: PaymentRecord[] };
};

export const callGetSubscriptionDetails = async (payload: { productId: string }) => {
  const fn = httpsCallable(functions, 'getSubscriptionDetails');
  const res = await fn(payload);
  return res.data as { subscription: SubscriptionInfo | null };
};

export const callRedeemPaymentLink = async (payload: { linkToken: string }) => {
  const fn = httpsCallable(functions, 'redeemPaymentLink');
  const res = await fn(payload);
  return res.data as {
    actionUrl: string;
    fields: Record<string, string>;
    linkData: {
      mode: 'subscription' | 'custom';
      productId: string;
      planId: string;
      itemName: string;
      amount: number;
      notes: string;
    };
  };
};
